import { api_base } from '../api';
import { dialog } from '../../scripts/confirm';
import { toast } from '../../scripts/toast';
import { router } from '../../routes/routes';
import Store from '../store';
import {
	setFedexQuote,
	setNationalQuote,
	logoutUser
} from '../actions';

export const BillingInfo = {
	// ---- GET (CURRENT USER) ----

	get(user, cb) {
		$.ajax({
			url: api_base + '/users/billingInfo/me',
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token,
			},

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}
				// console.log(err);
			}
		});
	},

	// ---- ADD ----

	add(user, data, options, cb) {
		$.ajax({
			url: api_base + '/users/billingInfo/me',
			method: 'POST',
			data: data,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res);

				if (!options.with_quote) {
					toast({
						title: 'Direcciones',
						content: 'Dirección guardada correctamente.'
					});
				}

				if (options.quote_fedex && !res.is_metroZone) {
					setFedexQuote(Store, user, options.index, options.product_id);
				}

				if (options.quote_national && !res.is_metroZone) {	
					setNationalQuote(Store, user, options.index);
				}
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					return toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				dialog({
					title: 'Direcciones',
					content: 'Error al añadir dirección.'
				});
				// console.log(err);
			}
		});
	},

	// ---- QUOTE ----

	quote(user, index, product_id, cb) {
		$.ajax({
			url: api_base + '/users/me/shoppingCart/quoteCart/' + index,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				// Issues when the response is empty.
				if (res) {
					cb(res.total);
				} else {
					cb('0');
				}
			},

			error: function (err) {
				if (err.status == 500) {
					cb('0');
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					cb('0');
					logoutUser(Store, '/home');
					return toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				cb('0');
				toast({
					title: 'Fedex',
					content: 'Verifica tus datos de envío.'
				});
				// console.log(err);
			}
		});
	},

	quoteNational(user, index, cb) {
		$.ajax({
			url: api_base + '/users/me/shoppingCart/quoteCartNational/' + index,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				// Issues when the response is empty.
				cb(res.price);
			},

			error: function (err) {
				if (err.status == 500) {
					cb('0');
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					cb('0');
					logoutUser(Store, '/home');
					return toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				cb('0');
				toast({
					title: 'Paquetería',
					content: 'Paqueteria no disponible.'
				});

				// console.log(err);
			}
		});
	},

	// ---- UPDATE ----
	// implement update in back.
	update(user, info, index, cb) {
		info._method = 'PUT';

		$.ajax({
			url: api_base + '/users/billingInfo/me/' + index,
			method: 'POST',
			data: info,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Actualizar Direccion',
					content: 'La dirección ha sido actualizada.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}
				// console.log(err);
			}
		});
	},

	// ---- REMOVE ----
	
	remove(user, info, cb) {
		$.ajax({
			url: api_base + '/users/billingInfo/me/' + info.id,
			method: 'DELETE',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				cb(info);
				toast({
					title: 'Eliminar Dirección',
					content: 'La dirección ' + info.street + ' ha sido eliminada.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}
				// console.log(err);
			}
		});
	},

	// ---- INVOICE ----

	invoice (user, payment_id, info, component) {
		$.ajax({
			url: `${ api_base }/users/me/purchaseOrders/${ payment_id }/requestInvoice`,
			method: 'POST',
			data: info,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				toast({
					title: 'Solicitar Factura',
					content: 'La solicitud se ha enviado.'
				});

				component.is_submited = false;
				router.go('/compras-previas');
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					return toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				toast({
					title: 'Solicitar Factura',
					content: 'Llena todos los campos o ya has enviado esta solicitud antes.'
				});

				component.is_submited = false;
			}
		});
	}
};


// WEBPACK FOOTER //
// ./src/store/api/billing_info.js